// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import LostPasswordComp from '../../components/LostPassword/LostPassword';

const LostPassword: React.FC = () => {
    return (
        <Entrypoint>
            <LostPasswordComp />
        </Entrypoint>
    );
}

export default LostPassword;